// @ts-nocheck
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  convertSecondsToTime,
  daysToSeconds,
  hoursToSeconds,
  minutesToSeconds,
} from '@lbca-shared/helpers/converter';
import { DatePickerComponent } from '../date-picker/date-picker.component';
import { TimePickerRefComponent } from '../timepicker/timepicker.component';

const threeHours = hoursToSeconds(3);
const oneDay = daysToSeconds(1);

@Component({
  selector: 'lbca-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrl: './date-time-picker.component.scss',
  imports: [DatePickerComponent, TimePickerRefComponent],
})
export class DateTimePickerComponent {
  public errorDate: Array<string> = [];
  public errorTime: Array<string> = [];
  public labelDateValue: string = '';
  public labelTimeValue: string = '';
  public helperTextValue: string = '';
  public isRequired: boolean = false;
  public isLabeled: boolean = true;
  public isEditable: boolean = false;
  public isDisabled: boolean = false;
  public isTabeled: boolean = false;
  public valueInput: number | null = null;

  public valueDate: number | null = null;

  @Input('error') set err(error) {
    this.errorDate = error
      .filter((err) => err?.field === 'date-picker' || err.field === undefined)
      .map((err) => err?.message ?? err);
    this.errorTime = error
      .filter((err) => err?.field === 'time-picker' || err.field === undefined)
      .map((err) => err?.message ?? err);
  }

  @Input() set value(val: number) {
    if (!val) return;

    this.valueDate = val - ((val - threeHours) % oneDay);
    this.valueInput = val;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = value;
  }
  @Input() set editable(value: boolean) {
    this.isEditable = value;
  }
  @Input() set tabeled(value: boolean) {
    this.isTabeled = value;
  }
  @Input() set labelDate(value: string) {
    this.labelDateValue = value;
  }
  @Input() set labelTime(value: string) {
    this.labelTimeValue = value;
  }
  @Input() rules: Array<any> = [];
  @Input() disabledDateRules: Array<any> = [];

  @Output('changeValue') changeEmmiter = new EventEmitter();

  @Output('setError') setErrorEmmiter = new EventEmitter();

  @Output() focusState = new EventEmitter();

  @Output('validStatus') validStatusEmmiter = new EventEmitter();

  constructor() {}

  public setFocus(focus): void {
    this.focusState.emit(focus);
  }

  public setValid(valid): void {
    this.validStatusEmmiter.emit(valid);
  }

  public changeDate($event) {
    const valueInput = this.valueInput;

    this.valueDate = $event;

    this.valueInput = valueInput === null ? $event : $event + ((valueInput - threeHours) % oneDay);

    this.changeEmmiter.emit(this.valueInput);
  }

  public changeTime($event) {
    const valueInput = this.valueInput || 0;
    const threeHours = hoursToSeconds(3);
    const oneDay = daysToSeconds(1);

    const [hour, minute] = $event.split(':');

    const hours = hoursToSeconds(hour);
    const minutes = minutesToSeconds(minute);
    const startDate = valueInput - ((valueInput - threeHours) % oneDay);

    this.valueInput = startDate + hours + minutes;

    this.changeEmmiter.emit(this.valueInput);
    this.setErrorEmmiter.emit([]);
  }

  public setErrorFn($event) {
    this.setErrorEmmiter.emit($event);
  }

  public formatToTimePiker(timestamp: number | null): string {
    if (!timestamp) return '';

    const threeHours = hoursToSeconds(3);
    const oneDay = daysToSeconds(1);

    const timeInSeconds = (timestamp - threeHours) % oneDay;

    return convertSecondsToTime(timeInSeconds);
  }
}
